import api from './api';

const labService = {
    // Test Management
    createTest: async (data) => {
        const response = await api.post('/lab/test', data);
        return response.data;
    },

    getTests: async () => {
        const response = await api.get('/lab/tests');
        return response.data;
    },

    getTest: async (id) => {
        const response = await api.get(`/lab/test/${id}`);
        return response.data;
    },

    updateTest: async (id, data) => {
        const response = await api.put(`/lab/test/${id}`, data);
        return response.data;
    },

    deleteTest: async (id) => {
        const response = await api.delete(`/lab/test/${id}`);
        return response.data;
    },

    // Patient Information (Limited View - name, phone, age only)
    getPatients: async () => {
        const response = await api.get('/lab/patients');
        return response.data;
    },

    getPatient: async (id) => {
        const response = await api.get(`/lab/patient/${id}`);
        return response.data;
    },

    // Patient Test History
    getPatientTests: async (patientId) => {
        const response = await api.get(`/lab/patient/${patientId}/tests`);
        return response.data;
    },

    // Attachments
    attachFile: async (testId, data) => {
        const response = await api.post(`/lab/test/${testId}/attach`, data);
        return response.data;
    },

    deleteAttachment: async (testId, attachmentIndex) => {
        const response = await api.delete(`/lab/test/${testId}/attach/${attachmentIndex}`);
        return response.data;
    },

    // Reports & Analytics
    getDashboard: async () => {
        const response = await api.get('/lab/report/dashboard');
        return response.data;
    },

    getTestsReport: async (filters = {}) => {
        const response = await api.get('/lab/report/tests', { params: filters });
        return response.data;
    },

    // ===== Branch lab queue (hospital mode) =====
    // Tests ordered by branch doctors that this lab must process.
    getIncomingTests: async (status) => {
        const response = await api.get('/tests/lab/incoming', {
            params: status ? { status } : {}
        });
        return response.data;
    },

    // Submit a result back onto the shared patient record.
    submitResult: async (testId, data) => {
        const response = await api.put(`/tests/${testId}/lab-result`, data);
        return response.data;
    },

    // Upload the printed/photographed result sheets. Returns the stored file
    // descriptors to send along with submitResult, so the doctor can read the
    // original document instead of the lab retyping it.
    uploadResultFiles: async (files) => {
        const formData = new FormData();
        files.forEach((file) => formData.append('files', file));
        const response = await api.post('/tests/lab/upload', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    },

    // ===== Lab test catalog (the menu of tests this branch lab offers) =====
    getCatalog: async () => {
        const response = await api.get('/tests/lab/catalog');
        return response.data;
    },

    addCatalogItem: async (data) => {
        const response = await api.post('/tests/lab/catalog', data);
        return response.data;
    },

    updateCatalogItem: async (id, data) => {
        const response = await api.put(`/tests/lab/catalog/${id}`, data);
        return response.data;
    },

    deleteCatalogItem: async (id) => {
        const response = await api.delete(`/tests/lab/catalog/${id}`);
        return response.data;
    }
};

export default labService;
